import { FC, useState } from 'react'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import styles from './index.module.scss'
import { IPublicUser } from '../../../types'
import { getUserAvatar, sanitizeUrl, useStores } from '../../../utils'
import { Avatar } from '../../atoms/Avatar'
import VerifiedBadgeSvg from '../../../public/images/common/verified_badge.svg'
import { JobTitleTag } from '../../atoms/JobTitleTag'
import { Button } from '../../atoms/Button'

type Props = {
  user: IPublicUser
}

export const FollowerItem: FC<Props> = ({ user }) => {
  const { t } = useTranslation(['p'])
  const link = sanitizeUrl(`/users/${user?.username}`)
  const { viewer } = useStores()
  const [isSubmitting, setIsSubmitting] = useState(false)

  const isMyAccount = user.username === viewer.viewer?.username

  const toggleFollow = async () => {
    if (viewer.isSignedIn && !isSubmitting) {
      setIsSubmitting(true)
      const newUser = await viewer.viewer?.toggleFollowUser(user.username)
      if (newUser) {
        user.update(newUser)
      }
      setIsSubmitting(false)
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.logo}>
        <Avatar src={getUserAvatar(user)} alt={user?.name} isOutline />
      </div>
      <div className={styles.content}>
        <div className={styles.heading}>
          <div className={styles.nameAndJob}>
            <Link href={link}>
              <a className={styles.link}>
                {user?.name}
                {user?.profile?.isVerifiedAccount && (
                  <span className={styles.badge}>
                    <VerifiedBadgeSvg />
                  </span>
                )}
              </a>
            </Link>
            <div className={styles.tagsList}>
              <JobTitleTag name={user?.profile?.jobTitle} />
            </div>
          </div>
          <div className={styles.follow}>
            {user?.isFollowing ? (
              <Button
                styleType='outline'
                color='lightGray'
                componentType='button'
                buttonSize='small'
                disabled={!(viewer.isSignedIn && !isMyAccount && !isSubmitting)}
                onClick={toggleFollow}
                isLoading={isSubmitting}
              >
                {t('フォロー中')}
              </Button>
            ) : (
              <Button
                styleType='default'
                color='blue'
                componentType='button'
                buttonSize='small'
                disabled={!(viewer.isSignedIn && !isMyAccount && !isSubmitting)}
                onClick={toggleFollow}
                isLoading={isSubmitting}
              >
                {t('フォロー')}
              </Button>
            )}
          </div>
        </div>
        <p className={styles.description}>{user?.profile?.bio}</p>
      </div>
    </div>
  )
}
